export const locales = {
	cancelBtn: 'Annuler',
	confirmBtn: 'Valider'
};
